import { render, staticRenderFns } from "./DiginetService.vue?vue&type=template&id=34335067&"
import script from "./DiginetService.vue?vue&type=script&lang=js&"
export * from "./DiginetService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports